var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mr-8" },
    [
      _c(
        "DefaultContentLayout",
        [
          _c(
            "div",
            [
              _c("ProjectCollectionFilters", {
                attrs: {
                  hideManagersFilter: _vm.isManager,
                  currentUserRole: _vm.currentUser.role,
                  currentUserId: _vm.currentUser.id,
                  companyId: _vm.company.id,
                  filters: _vm.projectFilters,
                },
                on: {
                  filtersChanged: _vm.updateFilters,
                  filtersReset: _vm.resetFilters,
                },
              }),
              _c(
                "h1",
                {
                  staticClass:
                    "font-semibold font-outfit leading-10 project-count mb-3",
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.draftTotal) + " Total draft profiles "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "LoadingOverlay",
            {
              attrs: {
                hasData: _vm.hasData,
                loading: _vm.isLoading,
                spinnerCentered: "",
              },
            },
            [
              _vm.empty
                ? _c(
                    "EmptyListPlaceholder",
                    {
                      attrs: { title: _vm.emptyListPlaceholder, subtitle: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "image",
                            fn: function () {
                              return [_c("EmptyListImageProjects")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4049957145
                      ),
                    },
                    [
                      _vm.filtersEmpty
                        ? _c("ProjectModalWithButton", {
                            attrs: {
                              companyId: _vm.company.id,
                              currentUser: _vm.currentUser,
                              size: "xl",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : [
                    _c("ProjectCardWrapper", {
                      attrs: {
                        projects: _vm.projects,
                        currentUser: _vm.currentUser,
                        companyId: _vm.company.id,
                      },
                      on: { projectUpdated: _vm.refetchProjects },
                    }),
                    _c("CardPagination", {
                      attrs: { config: _vm.paginationConfig },
                      on: {
                        "update:config": function ($event) {
                          _vm.paginationConfig = $event
                        },
                      },
                    }),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm.dialog
        ? _c("ProjectModal", {
            attrs: { companyId: _vm.company.id, currentUser: _vm.currentUser },
            on: {
              close: function ($event) {
                _vm.dialog = false
              },
            },
          })
        : _vm._e(),
      _c("router-view", {
        attrs: {
          company: _vm.company,
          currentUser: _vm.currentUser,
          canAddProject: "",
          totalClient: _vm.totalClient,
          draftTotal: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }